var _polygon, _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFairdropSelect(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "70px",
    height: "70px",
    viewBox: "0 0 70 70",
    enableBackground: "new 0 0 70 70",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#FFFFFF",
    points: "34.323,24.455 50.021,67.395 34.617,60.488 19.281,68.141  "
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M23.751,17.017l-7.132-7.132c-0.433-0.432-0.433-1.135,0-1.567l0.554-0.555c0.433-0.432,1.134-0.432,1.567,0 l7.132,7.133c0.433,0.435,0.433,1.135,0,1.567l-0.554,0.554C24.886,17.45,24.184,17.45,23.751,17.017"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M20.607,26.214H10.521c-0.612,0-1.108-0.496-1.108-1.107v-0.784c0-0.612,0.496-1.108,1.108-1.108h10.087 c0.612,0,1.108,0.496,1.108,1.108v0.784C21.715,25.718,21.219,26.214,20.607,26.214"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M35.042,13.303h-0.784c-0.612,0-1.108-0.495-1.108-1.107V2.108C33.15,1.496,33.646,1,34.258,1h0.784 c0.612,0,1.108,0.496,1.108,1.108v10.087C36.15,12.808,35.654,13.303,35.042,13.303"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M43.982,17.017l-0.555-0.554c-0.433-0.433-0.433-1.133,0-1.567l7.133-7.133c0.433-0.432,1.135-0.432,1.568,0 l0.554,0.555c0.433,0.433,0.433,1.136,0,1.567l-7.134,7.132C45.117,17.45,44.416,17.45,43.982,17.017"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M58.779,26.214H48.693c-0.613,0-1.108-0.496-1.108-1.107v-0.784c0-0.612,0.495-1.108,1.108-1.108h10.086 c0.612,0,1.108,0.496,1.108,1.108v0.784C59.888,25.718,59.392,26.214,58.779,26.214"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFairdropSelect);
export default __webpack_public_path__ + "static/media/fairdrop-select.99fa2128.svg";
export { ForwardRef as ReactComponent };